"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("@assets/css/_reset.scss");
require("@assets/css/_resetSelect.scss");
const layoutConfigs_1 = require("@configs/layoutConfigs");
const StatusModal_1 = __importDefault(require("@containers/common/Modals/StatusModal"));
const BreadCrumbs_1 = __importDefault(require("@layouts/BreadCrumbs"));
// import Sidebar from '@layouts/Sidebar';
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
// import Calendar from '../Calendar';
const Header_1 = __importDefault(require("../Header"));
require("./style.scss");
const PageLayout = () => {
    const commonState = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.common)));
    const { sidebarStatus } = commonState;
    const location = (0, react_router_dom_1.useLocation)();
    const handleChangeSidebarWidth = (isSidebarOpen) => {
        if (isSidebarOpen)
            document.documentElement.style.setProperty('--custom-sideBarWidth', layoutConfigs_1.layoutConfigs.SIDEBAR_WIDTH.expand);
        if (!isSidebarOpen)
            document.documentElement.style.setProperty('--custom-sideBarWidth', layoutConfigs_1.layoutConfigs.SIDEBAR_WIDTH.shrink);
    };
    const handleScrollToTop = () => document.querySelector('.main__content').scrollTo(0, 0);
    react_1.default.useEffect(() => handleChangeSidebarWidth(sidebarStatus.isOpen), [sidebarStatus.isOpen]);
    react_1.default.useEffect(() => handleScrollToTop(), [location]);
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(StatusModal_1.default, {}), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "pageLayout" }, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, {}), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "content__wrapper" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "main__content_wrapper" }, { children: [(0, jsx_runtime_1.jsx)(BreadCrumbs_1.default, {}), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "main__content" }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }))] })) }))] }))] }));
};
exports.default = PageLayout;
